import { css } from 'lit';
         export default css` 
         @charset "UTF-8";
/* ------------------------------------*\
    #BREAKPOINT VARIABLES
\*------------------------------------ */
/* ------------------------------------*\
    #TYPOGRAPHY APPLICATIONS
\*------------------------------------ */
/**
   * Visible focus outline 2px inside the element on a light background
   */
/**
   * Visible focus outline 2px inside the element on a dark background
   */
/**
   * Visible focus outline for elements on a light background
   */
/**
   * Invisible focus outline for elements that need a more visible
   * focus state for high-contrast mode
   */
/**
   * Visually hidden from display
   */
/**
   * style for text ellipsis
   */
/**
   * Popover attribute has default styling which comes from UA stylesheets which will be overridden here.
   */
/* ------------------------------------*\
    #VISIBILITY UTILITIES
\*------------------------------------ */
/* Completely remove from the flow and screen readers. */
.cat-u-is-hidden {
  display: none !important;
  visibility: hidden !important;
}

/* Completely remove from the flow but leave available to screen readers. */
.cat-u-is-vishidden {
  position: absolute !important;
  overflow: hidden;
  width: 1px;
  height: 1px;
  padding: 0;
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
}

/**
 * Hide element at sm breakpoint 
 */
@media all and (min-width: 23.4375rem) {
  .cat-u-hide-sm {
    display: none !important;
  }
}

/**
 * Hide element at sm-2 breakpoint 
 */
@media all and (min-width: 35rem) {
  .cat-u-hide-sm-2 {
    display: none !important;
  }
}

/**
 * Hide element at md breakpoint 
 */
@media all and (min-width: 48rem) {
  .cat-u-hide-md {
    display: none !important;
  }
}

/**
 * Hide element at lg breakpoint 
 */
@media all and (min-width: 60rem) {
  .cat-u-hide-lg {
    display: none !important;
  }
}

/**
 * Hide element at xl breakpoint 
 */
@media all and (min-width: 75rem) {
  .cat-u-hide-xl {
    display: none !important;
  }
}

/**
 * Show element at sm breakpoint 
 */
@media all and (max-width: 23.4375rem) {
  .cat-u-show-sm {
    display: none !important;
  }
}

/**
 * Show element at sm-2 breakpoint 
 */
@media all and (max-width: 35rem) {
  .cat-u-show-sm-2 {
    display: none !important;
  }
}

/**
 * Show element at md breakpoint 
 */
@media all and (max-width: 48rem) {
  .cat-u-show-md {
    display: none !important;
  }
}

/**
 * Show element at lg breakpoint 
 */
@media all and (max-width: 60rem) {
  .cat-u-show-lg {
    display: none !important;
  }
}

/**
 * Show element at xl breakpoint 
 */
@media all and (max-width: 75rem) {
  .cat-u-show-xl {
    display: none !important;
  }
}

/* ------------------------------------*\
    #RESET
\*------------------------------------ */
/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:focus-visible {
  outline-color: var(--cat-theme-color-focus-ring);
}

/* ------------------------------------*\
 #TIME-SELECTOR-LIST
\*------------------------------------ */
/**
 * Container for a heading and list of times
 */
.cat-c-time-selector-list {
  max-width: max-content;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: var(--cat-theme-color-background-default);
}
.cat-c-time-selector-list .cat-c-time-selector-list__top {
  width: calc(var(--size-base-unit) * 12.625);
}

/**
 * Inner container for list of times and set min height as per the figma to render time selector
 */
.cat-c-time-selector-list__inner {
  flex: 1 0 0;
  overflow: auto;
  min-height: calc(var(--size-base-unit) * 35.125);
  background-color: var(--cat-theme-color-background-default);
  /** 
   * Adjust scrollbar styles for consistent appearance across browsers
   */
  /**
   * Only show scrollbar when hovering over list for non-touch devices
   */
}
.cat-c-time-selector-list__inner::-webkit-scrollbar {
  background-color: transparent;
  width: calc(var(--size-base-unit) * 0.75);
}
@media not (hover: none) {
  .cat-c-time-selector-list__inner:hover::-webkit-scrollbar-thumb {
    border-radius: var(--cat-border-radius-md);
    background-color: var(--cat-theme-color-background-subtle-hover);
  }
}

/**
 * Horizontal list
 */
.cat-c-time-selector-list--horizontal .cat-c-time-selector-list__inner {
  display: flex;
  min-height: calc(var(--size-base-unit) * 7);
  padding-block-end: calc(var(--size-base-unit) * 0.275);
  padding-inline-start: 0;
  /** 
   * Adjust horizontal scrollbar dimensions
   */
}
.cat-c-time-selector-list--horizontal .cat-c-time-selector-list__inner::-webkit-scrollbar {
  width: auto;
  height: calc(var(--size-base-unit) * 0.75);
}

/**
 * Horizontal list
 */
.cat-c-time-selector-list--horizontal {
  max-width: none;
  height: auto;
}
.cat-c-time-selector-list--horizontal .cat-c-time-selector-list__top {
  margin-block-start: 0;
  margin-inline-end: 0;
  width: 100%;
  position: relative;
}

/**
 * Heading appearing before list of times
 */
.cat-c-time-selector-list__top {
  margin-block-start: -1px;
  margin-inline-end: calc(var(--size-base-unit) * 0.6987);
  padding-block-start: calc(var(--size-base-unit) * 0.375);
  background: var(--cat-theme-color-background-default);
}
.cat-c-time-selector-list__top .cat-c-time-selector-list__heading {
  font-family: var(--cat-theme-typography-label-font-family);
  font-weight: var(--cat-theme-typography-label-font-weight);
  font-size: var(--cat-theme-typography-label-font-size);
  line-height: var(--cat-theme-typography-label-line-height);
  margin: 0;
  color: var(--cat-theme-color-content-strong);
  font-weight: var(--cat-font-weight-bold);
  text-align: center;
  padding: calc(var(--size-base-unit) * 1.25) calc(var(--size-base-unit) * 1.25) calc(var(--size-base-unit) * 1.125);
  box-shadow: var(--cat-theme-box-shadow-sm);
  border-block-end: var(--cat-border-width-sm) solid var(--cat-theme-color-border-default);
  word-break: break-word;
  hyphens: auto;
}
.cat-c-time-selector-list--horizontal .cat-c-time-selector-list__top .cat-c-time-selector-list__heading {
  padding-block: calc(var(--size-base-unit) * 1.25);
  padding-inline: var(--cat-space-medium) 0;
  border-block-end: var(--cat-border-width-sm) solid var(--cat-theme-color-border-default);
}
.cat-c-time-selector-list--horizontal .cat-c-time-selector-list__top {
  padding-block-start: 0;
}

/** 
 * The actual list of times
 */
.cat-c-time-selector-list__list {
  list-style: none;
  padding: var(--cat-space-x-large) calc(var(--size-base-unit) * 0.25) calc(var(--size-base-unit) * 0.125);
  margin: 0;
  display: grid;
  justify-content: center;
  gap: var(--cat-space-3x-small);
  background-color: var(--cat-theme-color-background-default);
}
.cat-c-time-selector-list--horizontal .cat-c-time-selector-list__list {
  display: flex;
  padding: 0;
  padding-block: var(--cat-space-3x-small);
  margin-inline-start: var(--cat-space-3x-small);
}

/**
 * Individual time button
 */
.cat-c-time-selector-list__button {
  font-family: var(--cat-theme-typography-body-sm-font-family);
  font-weight: var(--cat-theme-typography-body-sm-font-weight);
  font-size: var(--cat-theme-typography-body-sm-font-size);
  line-height: var(--cat-theme-typography-body-sm-line-height);
  color: var(--cat-theme-color-content-default);
  text-transform: uppercase;
  background: none;
  border: 0;
  border-radius: calc(var(--size-base-unit) * 25);
  padding: calc(var(--size-base-unit) * 1.25) var(--cat-space-x-small);
  position: relative;
  cursor: pointer;
  white-space: nowrap;
  width: 100%;
  min-width: 5.5rem;
  transition: background-color var(--cat-anim-fade-quick) var(--cat-anim-ease), color var(--cat-anim-fade-quick) var(--cat-anim-ease);
  /**
   * Hover
   */
  /**
   * Focus states for dates
   */
  /**
   * Selected
   */
  /**
   * Disabled
   */
}
.cat-c-time-selector-list__button:hover {
  background-color: var(--cat-theme-color-background-subtle);
  cursor: pointer;
  outline: none;
}
.cat-c-time-selector-list__button:focus-visible {
  outline: 2px solid var(--cat-theme-color-focus-ring);
  outline-offset: var(--cat-theme-inset-focus-ring, -4px);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
}
.cat-c-time-selector-list__button:focus {
  outline: 2px solid var(--cat-theme-color-focus-ring);
  outline-offset: var(--cat-theme-inset-focus-ring, -4px);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
  --cat-theme-offset-focus-ring: 0;
}
.cat-c-time-selector-list__button.is-active {
  font-family: var(--cat-theme-typography-label-font-family);
  font-weight: var(--cat-theme-typography-label-font-weight);
  font-size: var(--cat-theme-typography-label-font-size);
  line-height: var(--cat-theme-typography-label-line-height);
  color: var(--cat-theme-color-content-knockout);
  background-color: var(--cat-theme-color-background-xstrong);
}
.cat-c-time-selector-list__button:disabled, .cat-c-time-selector-list__button:disabled:focus, .cat-c-time-selector-list__button:disabled:hover {
  color: var(--cat-theme-color-content-disabled);
  cursor: not-allowed;
  background: none;
}
`;
       